import React from 'react'; // } //   useCallback, //   useRef, //   useState, //   useMemo, //   useEffect, //   useReducer, // , {
import PropTypes from 'prop-types';

import classnames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Hidden from '@material-ui/core/Hidden';
import withStyles from '@material-ui/core/styles/withStyles';
import Grow from '@material-ui/core/Grow';

import loadable from '@loadable/component';
import { Link } from 'react-router-dom';
// import { Document, Page } from 'react-pdf';
// import { Document, Page } from 'react-pdf/dist/entry.webpack'

import debounce from 'lodash.debounce';
// import TouchScroll from '../vendor/touchScroll/TouchScroll.js';

import Loading from '../../components/Loading';
import AlertDialog from '../../components/AlertDialog';

// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import GestureHandler from './GestureHandler';
import GestureHandler__Experimental from './GestureHandler__Experimental';
import PdfThumbs from './PdfThumbs';
import { clamp, getCFUrl } from '../../helpers';
import '../../css/pdfViewer.css';
import '../../css/AnnotationLayer.css';
import { dateConvert } from '../../helpers/DateConvert';
import InfoBox from '../../components/InfoBox';

// import { PDFLinkService } from 'pdfjs-dist/lib/web/pdf_link_service';
// react-pdf is loaded asynchronously in componentDidMount (lifecycle methods aren't executed on the server)
// (it stopped working on node after I installed pdfjs build for the server side pdf stuff)

// let Document;
// let Hammer;
const Document = loadable.lib(() =>
  import(/* webpackChunkName: "react-pdf" */ 'react-pdf/dist/esm/entry.webpack')
);

const leftMargin = 0;
const DEFAULT_SCALE_DELTA = 1.3;

const styles = (theme) => ({
  navButton: {
    // padding: 24,
    color: theme.palette.blue.medium,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  page: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  pageHidden: {
    display: 'none',
    // opacity: 0.5,
  },
  appBar: {
    // boxShadow: 'none',
    zIndex: 1201,
    top: 0,
    backgroundColor: theme.palette.common.white,

    // backgroundColor: theme.palette.primary.dark,
  },
  toolBar: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  pdfTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
    },
  },
  pdfTitleText: {
    marginRight: '12px',
    fontWeight: 'bold',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '0.75rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    lineHeight: 1.5,
  },
  pdfSubTitleText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '0.75rem',
    lineHeight: 1.5,
  },
  paginationMenuItem: { fontSize: 16, padding: '12px 24px' },
  buttonRoot: {
    color: theme.palette.primary.main,
    '&$iconButtonDisabled': {
      color: 'rgba(9 14 68, 0.35)',
    },
  },
  iconButtonDisabled: {},
  absoluteCenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  pdfThumbContainer: {
    // width: '100%',
    position: 'fixed',
    height: '100%',
    // bottom: 0,
    top: 64,
    left: -420,
    zIndex: 2,
    backgroundColor: theme.palette.common.white,
    // changed to draggable
    // overflow: 'scroll',
    paddingTop: 16,
    paddingBottom: 60,
    paddingRight: 16,
    paddingLeft: 16,
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  pdfThumbContainerIn: {
    boxShadow: '0px 10px 85px rgba(0,0,0,0.3)',
    left: 0,
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  pdfThumbDoc: {
    display: 'block',
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: 'center',
  },
  pdfThumbDpsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
  },
  pdfThumbItem: {
    padding: '12px 8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    flexShrink: 0,
    flexBasis: 'auto',
  },
  pdfThumbLabel: {
    flexDirection: 'column',
    display: 'flex',
  },
  pdfThumbBorder: {
    border: '1px solid #dadada',
    transition: 'all 200ms ease',
    '&:hover': {
      border: '1px solid #333',
      transition: 'all 200ms ease',
    },
  },
  pdfThumbCurrent: {
    transition: 'all 200ms ease',
    border: '1px solid #333',
  },
  pdfThumbImg: {
    userSelect: 'none',
    '-webkit-user-drag': 'none',
    width: '100%',
    height: 'auto',
    maxWidth: 75,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 100,
    },
    // minWidth: 75,
  },

  // draggable: {
  //  overflowX: 'scroll',
  //  overflowY: 'scroll',
  // },
  pdfBox: {
    // overflowX: 'scroll',
    // overflowY: 'scroll',
    overflow: 'hidden',
    position: 'relative',
    width: '100vw',
    // minHeight: `calc(100vh - ${topMargin}px)`,
    // marginTop: topMargin,
    display: 'flex',
    // alignItems:'center',
    // justifyContent: 'center',
  },
  hideOverflow: {
    overflow: 'hidden',
  },
  pdfDocument: {
    display: 'flex',
    // margin: 'auto',
    // flexGrow: 1,
    // flex: 1,
    position: 'absolute',
    alignItems: 'safe center',
    justifyContent: 'safe center',
  },
  container: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      margin: '-24px',
    },
    margin: 0,
    display: 'flex',
  },
  showPageL: {
    opacity: 1,
    // transform: 'translateX(0px)',
    transition: 'opacity 450ms ease',
  },
  hidePageL: {
    opacity: 0.5,
    // transform: 'translateX(5px)',
    transition: 'opacity 350ms ease-out',
  },
  showPageR: {
    opacity: 1,
    // transform: 'translateX(0px)',
    transition: 'opacity 450ms ease',
  },
  hidePageR: {
    opacity: 0.5,
    // transform: 'translateX(-5px)',
    transition: 'opacity 350ms ease-out',
  },
  pdfControls: { display: 'flex' },
  toggleZoomWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toggleZoomIconContainer: {
    borderRadius: 0,
    border: '2px solid',
    alignSelf: 'center',
  },
  toggleZoomIcons: {
    transition: 'all 250ms ease',
  },
  toggleZoomIconRow1: {
    position: 'absolute',
    transform: 'rotate(90deg) translateY(8px)',
  },
  toggleZoomIconRow2: {
    position: 'absolute',
    transform: 'rotate(90deg) translateY(-8px)',
  },
  toggleZoomIconCol1: {
    position: 'absolute',
    transform: 'rotate(180deg) translateY(8px)',
  },
  toggleZoomIconCol2: {
    position: 'absolute',
    transform: 'rotate(180deg) translateY(-8px)',
  },
  toggleZoomCol: {
    transition: 'all 300ms 50ms ease',
    flexDirection: 'column',
    height: 40,
    width: 36,
  },
  toggleZoomRow: {
    transition: 'all 300ms 50ms ease',
    flexDirection: 'row',
    width: 40,
    height: 36,
  },

  pdfToolsLeft: {
    bottom: 0,
    left: 0,
    padding: 24,
    position: 'fixed',
    zIndex: 2,
    opacity: 0,
    opacity: 1,
    transition: theme.transitions.create(['bottom', 'opacity'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
      delay: 500,
    }),
  },
  pdfToolsRight: {
    bottom: 0,
    right: 0,
    padding: 24,
    position: 'fixed',
    zIndex: 2,
    opacity: 0,
    opacity: 1,
    transition: theme.transitions.create(['bottom', 'opacity'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
      delay: 500,
    }),
  },
});

const ScrollIndicator = ({ transform, pos, last_posY }) => (
  <React.Fragment>
    <span
      style={{
        position: 'absolute',
        width: 30,
        height: 'calc(50% + 1px)',
        backgroundColor: 'rgba(0,0,0,0.3)',
        borderTopRightRadius: pos === 'left' ? '100%' : 0,
        borderTopLeftRadius: pos === 'right' ? '100%' : 0,
        top: 0,
        left: pos === 'left' ? 0 : 'inherit',
        right: pos === 'right' ? 0 : 'inherit',
        zIndex: 1,
        transition: 'all 200ms ease',
        transformOrigin: pos === 'left' ? '0px 100% 0px' : '100% 0px 0px',
        transform:
          pos === 'left'
            ? `scaleX(${Math.abs(transform)})`
            : `scaleX(${transform})`,
      }}
    />
    <span
      style={{
        position: 'absolute',
        width: 30,
        height: 'calc(50% - 1px)',
        backgroundColor: 'rgba(0,0,0,0.3)',
        borderBottomRightRadius: pos === 'left' ? '100%' : 0,
        borderBottomLeftRadius: pos === 'right' ? '100%' : 0,
        bottom: 0,
        left: pos === 'left' ? 0 : 'inherit',
        right: pos === 'right' ? 0 : 'inherit',
        zIndex: 1,
        transition: 'all 200ms ease',
        transformOrigin: pos === 'left' ? '0px 100% 0px' : '100% 0px 0px',
        transform:
          pos === 'left'
            ? `scaleX(${Math.abs(transform)})`
            : `scaleX(${transform})`,
      }}
    />
  </React.Fragment>
);

const PaginationMenuItem = ({
  className,
  handlePageChange,
  page,
  children,
}) => {
  const onClick = () => handlePageChange(page);
  return (
    <MenuItem className={className} onClick={onClick}>
      {children}
    </MenuItem>
  );
};
const Pagination = ({
  pageNumber,
  numPages,
  dps,
  isDps,
  handleFirst,
  handleLast,
  handlePrevious,
  handleNext,
  handleKeyPress,
  paginationAnchorEl,
  paginationMenuItem,
  handlePageChange,
  buttonRoot,
  setAnchorEl,
  disabledClass,
}) => {
  const disableLeft = pageNumber === 1;
  const disableRight =
    pageNumber === numPages ||
    (pageNumber !== 1 && dps && pageNumber + 1 === numPages);

  return (
    <div style={{ display: 'flex' }}>
      <Hidden smDown>
        <IconButton
          disableRipplez
          disabled={disableLeft}
          color="primary"
          onClick={handleFirst}
          classes={{
            root: buttonRoot,
            disabled: disabledClass,
          }}
        >
          <Icon>first_page</Icon>
        </IconButton>
      </Hidden>
      <IconButton
        color="primary.main"
        disableRipplez
        disabled={disableLeft}
        onClick={handlePrevious}
        classes={{
          root: buttonRoot,
          disabled: disabledClass,
        }}
      >
        <Icon>arrow_back</Icon>
      </IconButton>
      <Hidden smDown>
        <div
          style={{ display: 'flex', alignItems: 'center' }}
          key="pageIndicator"
        >
          <Tooltip
            id="tooltip-page-indicator"
            title="Go to page..."
            placement="bottom"
          >
            <Button
              aria-owns={paginationAnchorEl ? 'page-navigation' : null}
              aria-haspopup="true"
              onClick={(event) => setAnchorEl(event.currentTarget)}
              disabled={numPages === 1}
            >
              <Typography
                style={{ display: 'inline', fontSize: 14 }}
                headlineMapping={{ body1: 'span' }}
                variant="body1"
              >
                {!isDps ? pageNumber : `${pageNumber} - ${pageNumber + 1}`}{' '}
                {/* of {numPages} */}
              </Typography>
            </Button>
          </Tooltip>
          <Menu
            id="page-navigation"
            value={pageNumber}
            anchorEl={paginationAnchorEl}
            open={Boolean(paginationAnchorEl)}
            onClose={(_) => setAnchorEl(null)}
            className={'page-indicator'}
          >
            {Array.from(new Array(numPages), (el, index) => {
              const page = index + 1;
              const secondPage = page + 1;
              return dps ? (
                page === 1 ? (
                  <PaginationMenuItem
                    page={page}
                    className={paginationMenuItem}
                    key={`page_${page}`}
                    handlePageChange={handlePageChange}
                  >
                    {page}
                  </PaginationMenuItem>
                ) : (
                  index % 2 && (
                    <PaginationMenuItem
                      page={page}
                      className={paginationMenuItem}
                      key={`page_${page}`}
                      handlePageChange={handlePageChange}
                    >
                      {secondPage <= numPages
                        ? `${page} - ${secondPage}`
                        : page}
                    </PaginationMenuItem>
                  )
                )
              ) : (
                <PaginationMenuItem
                  page={page}
                  className={paginationMenuItem}
                  style={{ fontSize: 14, padding: '6px 10px' }}
                  key={`page_${page}`}
                  handlePageChange={handlePageChange}
                >
                  {page}
                </PaginationMenuItem>
              );
            })}
          </Menu>
        </div>
      </Hidden>
      <IconButton
        color="primary.main"
        disableRipplez
        disabled={disableRight}
        onClick={handleNext}
        onKeyPress={handleKeyPress}
        classes={{
          root: buttonRoot,
          disabled: disabledClass,
        }}
      >
        <Icon>arrow_forward</Icon>
      </IconButton>
      <Hidden smDown>
        <IconButton
          color="primary.main"
          disableRipplez
          disabled={disableRight}
          onClick={handleLast}
          classes={{
            root: buttonRoot,
            disabled: disabledClass,
          }}
        >
          <Icon>last_page</Icon>
        </IconButton>
      </Hidden>
    </div>
  );
};

const isClient = typeof window !== 'undefined';
const isDesktop = isClient && window.innerWidth > 768;

const INITIAL_TOP_MARGIN = 64;

class PdfViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      annotations: [],
      showPdf: false,
      showThumbs: false,
      pageRenderedL: false,
      pageRenderedR: false,
      numPages: null,
      pageNumber: 1,
      pageRenderedBeginning: false,
      pageRenderedMiddle: false,
      pageRenderedEnd: false,
      pageCursor: 'middle',
      beginningPage: null,
      middlePage: 1,
      endPage: 2,
      containerWidth: null,
      containerHeight: null,
      pdfWidth: null,
      pdfHeight: null,
      topMargin: 64,
      fitWidth:
        isClient &&
        window.innerHeight * (window.innerWidth / window.innerHeight),
      fitHeight: isClient && window.innerHeight - 64,
      fillWidth: isClient && window.innerWidth,
      width: isClient && window.innerWidth,
      height: isClient && window.innerHeight - 64,
      MIN_WIDTH:
        isClient && (isDesktop ? window.innerWidth / 2 : window.innerWidth), // this should change depnding on dps
      MAX_WIDTH: isClient
        ? !isDesktop
          ? window.innerWidth * (DEFAULT_SCALE_DELTA * 3)
          : window.innerWidth * DEFAULT_SCALE_DELTA * 1.5
        : 0,
      // canvas: {
      //   width: isClient && window.innerWidth / DEFAULT_SCALE_DELTA,
      //   height: isClient && window.innerHeight / DEFAULT_SCALE_DELTA,
      // },
      pageFillScale: 1,
      pageFitScale: 1,
      pageFitOrFill: true,
      zoom: 1,
      dps: isDesktop,
      toggleZoom: isDesktop ? 'fit' : 'fill',
      pageFitOrFill: true,
      showLightBox: false,
      mouseDown: false,
      direction: 'right',
    };
    this.resizeObserver = null;
  }

  componentWillUnmount() {
    if (isClient) {
      document.body.style = null;
      console.log('removeEventListener');
      document.removeEventListener('keydown', this.handleKeys, false);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      } else {
        window.removeEventListener('resize', this.debounceResize);
      }
    }
  }

  async componentDidMount() {
    if (this.props.location?.search) {
      console.log('page N on mount', this.props.location.search);
      if (this.props.location.search.startsWith('?p=')) {
        this.handlePageChange(
          Number(this.props.location.search.split('?p=')[1]),
          true
        );
      }
    }
    // Document =  require('react-pdf/dist/entry.webpack');
    // Hammer = require('hammerjs');
    this.setState({
      showPdf: true,
      params: this.props.location?.match?.params,
    });

    // this.updateWindowDimensions();
    if (this.props.pdf) {
      document.title = `AJN PDFS | ${this.props.pdf.publication} - ${this.props.pdf.edition} ${this.props.pdf.monthPublished} ${this.props.pdf.yearPublished}`;
    }
    // fix issues with onWheel in safari / magic mouse
    if (isClient) document.body.style.overflow = 'hidden';
  }

  debounceResize = debounce((e) => {
    this.updateWindowDimensions(e);
  }, 500);

  getFitWidth = (height, ratio) => height * ratio;

  updateWindowDimensions = (e) => {
    console.log('update window dims', e);

    this.setPdfRatio();

    if (e && e[0] && e[0].contentRect) {
      const rect = e[0].contentRect;
      console.log('window d dps', this.isDps());
      const { pdfRatio } = this.state;

      const fill = this.isDps() ? rect.width / 2 : rect.width;
      // this is the ony way to get the correct fit width
      // although react-pdf doesn't require it; we use height instead
      // the gesture handler relies on the currentWidth prop.
      const fitWidth = this.getFitWidth(rect.height, pdfRatio);

      this.setState({
        showLightBox: false,
        width: rect.width,
        height: rect.height,
        fitHeight: rect.height,
        fillWidth: fill,
        fitWidth,
      });
    } else {
      const { ratio } = this.state;

      const fitWidth = this.getFitWidth(window.innerHeight - margin, pdfRatio);

      const margin = window.innerWidth < 600 ? 66 : 64;
      const fill = this.isDps() ? window.innerWidth / 2 : window.innerWidth;
      this.setState({
        showLightBox: false,
        topMargin: margin,
        width: window.innerWidth,
        height: window.innerHeight - margin,
        fitHeight: window.innerHeight - margin,
        fillWidth: fill,
        fitWidth,
      });
    }

    this.setPageFitOrFill();
  };

  componentWillReceiveProps(nextProps) {
    // this.onRenderSuccessL();
    // this.onRenderSuccessR();
    // if (nextProps.location.hash) {
    //   console.log(nextProps.location);
    //   if (nextProps.location.hash.split('?v=').length) {
    //     console.log(nextProps.location.hash.split('?v=')[1]);
    //     this.setState({
    //       showLightBox: true,
    //       lightBoxContent: nextProps.location.hash.split('?v=')[1],
    //     })
    //   }
    // }
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.pdf !== nextProps.pdf) {
  //     return true;
  //   }
  //   if ( this.state.pageNumber !== nextState.pageNumber){
  //     return true;
  //   }
  //   if (this.state.zoom !== nextState.zoom ){
  //     return true;
  //   }
  //   if ( this.state.computedWidth !== nextState.computedWidth ) {
  //     return true;
  //   }
  //   if ( this.state.MIN_WIDTH !== nextState.MIN_WIDTH) {
  //     return true;
  //   }
  //    if ( this.state.MAX_WIDTH !== nextState.MAX_WIDTH) {
  //     return true;
  //   }
  //    if ( this.state.dps !== nextState.dps) {
  //     return true;
  //   }
  //    if ( this.state.anchorEl !== nextState.anchorEl) {
  //     return true;
  //   }
  //   if ( this.state.toggleZoom !== nextState.toggleZoom ) {
  //     return true;
  //   }
  //   return false;
  // }

  handleMouseDown = (e) => {
    // e.stopPropagation();
    this.setState({ mouseDown: true });
  };

  handleMouseUp = () => {
    // e.stopPropagation();
    this.setState({ mouseDown: false });
  };

  closeLightBox = () => {
    this.setState({ showLightBox: false });
  };

  handleKeys = (event) => {
    // left arrow

    if (event.keyCode === 37) {
      this.handlePrevious();
    }
    // right arrow
    if (event.keyCode === 39) {
      this.handleNext();
    }
    // esc
    if (event.keyCode === 27 && !this.state.toggleZoom) {
      this.handleZoomReset();
    }
    // equals (plus)
    if (event.keyCode === 187) {
      this.handleZoomIn();
    }
    // minus
    if (event.keyCode === 189) {
      this.handleZoomOut();
    }
  };

  reCenter = () => {
    console.log('recenter');
    this.setPageFitOrFill();
    this.center();
  };

  goBack = () => {
    this.props.goBack();
  };

  onDocumentLoad = (pdf) => {
    console.log('add EventListeners on document load');
    this.setState({ el: document.querySelector('.react-pdf__Document') });

    isClient && document.addEventListener('keydown', this.handleKeys, false);

    if (isClient) {
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(this.debounceResize);
        this.resizeObserver.observe(document.getElementById('drag-wrapper'));
      } else {
        // Browser support, remove freely
        window.addEventListener('resize', this.debounceResize);
      }
    }

    console.log(pdf);
    this.setState({ numPages: pdf.numPages });
    // this.updateWindowDimensions();
    // this.reCenter();
  };

  onLoadProgress = ({ loaded, total }) => {
    console.log(loaded, total, `${(loaded / total) * 100}%`);
  };

  onPageLoadL = (page) => {
    console.log('page rendered L false');
    this.setState({
      pdfWidth: page.width,
      pdfHeight: page.height,
      pageRenderedL: false,
      showThumbs: false,
    });
    // only resize & center here if left page will be the final page (not DPS)
    !this.isDps() && this.reCenter(page);
  };

  onPageLoadR = (page) => {
    // only setting the page style, and not the pdf width/height here
    // as the onPageLoadL function will always fire.
    // edge case would be second page having a different size...
    console.log('page rendered R false');
    this.setState({
      pageRenderedR: false,
    });
    // do the resizing & centering after final page has loaded
    this.reCenter(page);
  };

  onRenderSuccessL = () => {
    const { toggleZoom } = this.state;
    console.log('page rendered L');
    this.setState({ pageRenderedL: true });
    // toggleZoom && this.center();
  };

  onRenderSuccessR = () => {
    const { toggleZoom } = this.state;
    console.log('page rendered R');
    this.setState({ pageRenderedR: true });
    // toggleZoom && this.center();
  };

  onPageLoadBeginning = () => {
    this.setState({ pageRenderedBeginning: false });
  };
  onPageLoadMiddle = () => {
    this.setState({ pageRenderedMiddle: false });
  };
  onPageLoadEnd = () => {
    this.setState({ pageRenderedEnd: false });
    this.setPageFitOrFill();
  };

  onRenderSuccessBeginning = () => {
    this.setState({ pageRenderedBeginning: true });
  };
  onRenderSuccessMiddle = () => {
    this.setState({ pageRenderedMiddle: true });
  };
  onRenderSuccessEnd = () => {
    this.setState({ pageRenderedEnd: true });
  };

  // setCanvas = () => {
  //   //  page.rect = el.getBoundingClientRect();
  //   const c = document
  //     .querySelector('.react-pdf__Page__canvas')
  //     .getBoundingClientRect();
  //   c &&
  //     this.setState({
  //       canvas: {
  //         width: c.width,
  //         height: c.height,
  //       },
  //     });
  // };

  center = () => {
    // literally just toggling it, to force the
    // getsture handler's useEffect to call center()
    this.setState({ center: !this.state.center });
    // this.handler && this.handler.center();
  };
  setPdfRatio = () => {
    const { el } = this.state;
    if (el) {
      const { width: pdfWidth, height: pdfHeight } = el.getBoundingClientRect();
      const w = this.isDps() ? pdfWidth / 2 : pdfWidth;
      const ratio = w / pdfHeight;
      console.log('setting pdf ratio:', ratio);
      this.setState({ pdfRatio: ratio });
    }
  };

  setPageFitOrFill = () => {
    const { toggleZoom } = this.state;

    if (toggleZoom === 'fit') {
      this.setPageFit();
    } else {
      this.setPageFill();
    }
  };

  toggleDps = () => {
    console.log('dps before toggle', this.state.dps);
    const { height, width, pageNumber, pdfRatio } = this.state;
    const current = this.isDps(); //this.state.dps;
    const next = this.isDps({ dps: !this.state.dps }); //this.state.dps;

    // if single to dps and odd page, go back a page
    // so the spread is even + odd

    this.setState({
      dps: !this.state.dps,
      moreAnchorEl: null,
    });

    // oh this needs to be based on isDps() rather than the toggled dps val
    let cw;
    cw = !next ? width : width / 2;

    const fitWidth = this.getFitWidth(height, pdfRatio);

    console.log('dps change', current, {
      fillWidth: cw,
      fitWidth,
      fitHeight: height,
    });
    this.setState(
      {
        fillWidth: cw,
        fitWidth,
        fitHeight: height,
      },
      () => {
        if (!current && pageNumber % 2 === 1) {
          this.handlePrevious();
          // return because page change triggers page fit/fill (setPageFitOrFill)
          return;
        }
        this.setPageFitOrFill();
      }
    );
    // no this toggle's it
    // this.handleZoomReset();
  };

  /**
  |--------------------------------------------------
  | Annotation stuff
  |--------------------------------------------------
  */
  getAnnotationsL = (annotationsL) => {
    console.log({ annotationsL });
    this.setState({ annotationsL });
    this.onRenderAnnotationsSuccessL();
  };

  getAnnotationsR = (annotationsR) => {
    console.log({ annotationsR });
    this.setState({ annotationsR });
    this.onRenderAnnotationsSuccessR();
  };

  getAnnotations = (annotations, page) => {
    console.log('get annotations', page);
    if (this.state[`annotations-${page}`]) return;
    console.log({ annotations });
    this.setState({ [`annotations-${page}`]: annotations });
  };

  onRenderAnnotations = (annotations) => {
    // attempt to show lightbox with youtube embed
    // setTimeout(() => {
    //   annotations &&
    //     annotations.forEach((ann) => {
    //       if (ann.url) {
    //         this.bindVideoEmbed(ann);
    //       }
    //     });
    // }, 500);
  };

  onRenderAnnotationsSuccessL = () => {
    // this.setState({
    //   showLightBox: true,
    //   lightBoxContent: 'asdf',
    // })
    setTimeout(() => {
      this.state.annotationsL &&
        this.state.annotationsL.forEach((ann) => {
          if (ann.url) {
            this.bindVideoEmbed(ann);
          }
        });
    }, 500);
  };

  // onRenderAnnotationsSuccessR = () => {
  //   console.log('onrenderaintaoernt');

  //   setTimeout(() => {
  //     this.state.annotationsR &&
  //       this.state.annotationsR.forEach((ann) => {
  //         console.log('annR', ann);

  //         if (ann.url) {
  //           this.bindVideoEmbed(ann);
  //         }
  //       });
  //   }, 500);
  // };

  // this is really inconsistent
  // with the annotation layer elements
  // being added / removed.
  // the nodes are refreshed after clicking
  // so the event listeners get lost.
  bindVideoEmbed = (ann) => {
    if (!isClient) return;
    const parts = ann.url.split('.');
    console.log(parts);
    // matches a youtube url and captures the id
    // (https://)youtu.be/xxxxxxxxxxx
    // (https://)youtube.com/?v=xxxxxxxxxxx
    const test = new RegExp(
      /(?:youtu.be\/|youtube.com\/)(?:watch?.*\bv=|embed\/|v\/|ytimg.com\/vi\/)?(.+?)(?:[^-a-zA-Z0-9]|$)/
    );
    const vidId = ann.url.match(test);
    console.log('vidid', vidId);

    if (!vidId) return;
    if (!vidId[1]) return;

    const elements = document.querySelectorAll(
      `[data-annotation-id="${ann.id}"]`
    );
    console.log(elements);
    // should only have an <a/> in it
    elements &&
      elements.forEach((el) => {
        console.log('adding click handler to', el);

        el.addEventListener(
          'click',
          (e) => {
            console.log('click!', vidId[1]);
            e.preventDefault();
            e.stopPropagation();
            this.setState({
              showLightBox: true,
              lightBoxContent: vidId[1],
            });
          },
          true
        );
        // el.firstElementChild.setAttribute(
        //   'href',
        //   `#?v=${parts[2].split('?v=')[1]}`
        // );
        // el.firstElementChild.removeAttribute('href');
        console.log(el.firstElementChild);
      });
  };

  internalLinkPress = ({ pageNumber }) => {
    console.log(pageNumber);
    this.handlePageChange(pageNumber);
  };

  pinchend = (scale) => {
    scale < 3 && this.handleZoomIn(scale);
  };

  handleDoubleClick = () => {
    // const { computedWidth, MIN_WIDTH, MAX_WIDTH } = this.state;
    // this.handleZoomReset;
    this.handleZoomIn();

    // else if (computedWidth < MAX_WIDTH) {
    //   this.handleZoomIn(3);
    // }
  };
  setPaginationAnchor = (el) => this.setState({ paginationAnchorEl: el });

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleNext;
    }
  };

  handlePageChange = (pg, noHistoryUpdate) => {
    let page = pg;
    const {
      numPages,
      toggleZoom,
      pdfRatio,
      pageCursor,
      beginningPage,
      middlePage,
      width,
      height,
      endPage,
      pageNumber,
    } = this.state;
    console.log('numpages', numPages, page);
    // page can be passed to the url like ?p=asdf
    if (typeof page !== 'number') return;
    // uhh numPages might not be (def isn't) defined yet when page changed on mount from URL
    if (page < 1 || (numPages && page > numPages) || page === pageNumber)
      return;
    console.log(
      'is odd ?',
      this.isDps({ pageNumber: page, numPages }),
      page % 2
    );
    // provide page to isDps so it isn't using initial state
    if (
      // we can't have a page zero
      page > 1 &&
      page <= numPages &&
      this.isDps({ pageNumber: page, numPages }) &&
      page % 2 === 1
    ) {
      // this is nat a var
      console.log('hitting odd page when in DPS mode');
      page--;
    }

    const isDps = this.isDps({ pageNumber: page, numPages });

    // close the menu if it's open
    this.setPaginationAnchor(null);

    const { slug, type } = this.props.match.params;
    // add the page number to the search param
    !noHistoryUpdate &&
      this.props.history.replace(`/view/${type}/${slug}?p=${page}`);

    this.setState({
      pageNumber: page,
    });
    if (this.state[`annotations-${page}`]) {
      this.onRenderAnnotations(this.state[`annotations-${page}`]);
    }

    // we need to set the correct fit/fill widths
    // because changing from first or last page on dps
    // will require new vals
    const fitWidth = this.getFitWidth(height, pdfRatio);
    const w = isDps ? width / 2 : width;
    console.log('handlepage new fillWidth', w);
    this.setState(
      {
        fillWidth: w,
        fitWidth, // this isn't right when on single fit??
        fitHeight: height,
      },
      () => {
        this.setPageFitOrFill();
        // this.center();
      }
    );

    // center after page changing (in fill center brings the x to the top and y to the center, go figure)
    // if ((isDps && toggleZoom === 'fill') || !isDps) {
    // really need to do some checks based on the
    // orentation
    // or just if pdf width > screen width don't center?

    // }

    const pageSkipNumber = isDps ? 2 : 1;

    const pages = [beginningPage, middlePage, endPage];
    if (!pages.includes(page)) {
      // signifies a jump in pages rather than next/back
      console.log('page jump & return set middle cursor - ', {
        beginningPage: page - pageSkipNumber,
        middlePage: page,
        endPage: page + pageSkipNumber,
      });
      this.setState({
        beginningPage: page - pageSkipNumber,
        middlePage: page,
        endPage: page + pageSkipNumber,
        pageCursor: 'middle',
      });
      return;
    }

    console.group('Page change');
    console.log('page: ', page);
    console.log('cursor: ', pageCursor);
    console.log('beginningPage: ', beginningPage);
    console.log('middlePage: ', middlePage);
    console.log('endPage: ', endPage);

    let nextCursor;
    const direction = page > pageNumber ? 'right' : 'left';

    // have fun converting this to dps lmao
    if (pageCursor === 'beginning' && direction === 'right')
      nextCursor = 'middle';
    if (pageCursor === 'middle' && direction === 'right') nextCursor = 'end';
    if (pageCursor === 'end' && direction === 'right') nextCursor = 'beginning';
    if (pageCursor === 'end' && direction === 'left') nextCursor = 'middle';
    if (pageCursor === 'middle' && direction === 'left')
      nextCursor = 'beginning';
    if (pageCursor === 'beginning' && direction === 'left') nextCursor = 'end';

    console.log('new cursor', nextCursor);
    console.groupEnd();

    // literally what is this shit
    if (pageCursor === 'middle' && nextCursor === 'end') {
      // went from middle to end, render next page at the beginning
      this.setState({
        beginningPage: page + pageSkipNumber,
      });
    }
    if (pageCursor === 'end' && nextCursor === 'beginning') {
      // went from end to beginning, render next page at the middle
      this.setState({
        middlePage: page + pageSkipNumber,
      });
    }
    if (pageCursor === 'beginning' && nextCursor === 'middle') {
      // went from beginning to end, render next page at the middle
      this.setState({
        endPage: page + pageSkipNumber,
      });
    }

    if (pageCursor === 'end' && nextCursor === 'middle') {
      // went from end to middle, render next page at the beginning
      this.setState({
        beginningPage: page - pageSkipNumber,
      });
    }
    if (pageCursor === 'middle' && nextCursor === 'beginning') {
      // went from middle to beginning, render next page at the end
      this.setState({
        endPage: page - pageSkipNumber,
        // endPage: page + pageSkipNumber, // uhhhh
      });
    }
    if (pageCursor === 'beginning' && nextCursor === 'end') {
      // went from beginning to end, render next page at the middle
      this.setState({
        middlePage: page - pageSkipNumber,
      });
    }

    this.setState({ pageCursor: nextCursor });
  };

  handlePrevious = () => {
    this.setState({ direction: 'left' });

    const { pageNumber, numPages, dps } = this.state;
    if (pageNumber === 1) {
      return;
    }

    this.handlePageChange(
      dps && pageNumber !== 2 ? pageNumber - 2 : pageNumber - 1
    );
    // if (dps) {
    //   pageNumber === 2
    //     ? this.handlePageChange(pageNumber - 1)
    //     : this.handlePageChange(pageNumber - 2)
    // } else {
    //   this.handlePageChange(pageNumber - 1)
    // }
  };

  handleNext = () => {
    console.log('next');
    this.setState({ direction: 'right' });
    const { pageNumber, numPages, dps } = this.state;
    const disableRight =
      pageNumber === numPages ||
      (pageNumber !== 1 && dps && pageNumber + 1 === numPages);

    if (disableRight) {
      return;
    }

    if (dps) {
      pageNumber === 1 || pageNumber === numPages - 1
        ? this.handlePageChange(pageNumber + 1)
        : this.handlePageChange(pageNumber + 2);
    } else {
      this.handlePageChange(pageNumber + 1);
    }
  };

  handleFirst = () => {
    if (this.state.pageNumber === 1) {
      return;
    }
    this.handlePageChange(1);
  };

  handleLast = () => {
    if (this.state.pageNumber === this.state.numPages) {
      return;
    }
    this.handlePageChange(this.state.numPages);
  };

  handleZoom = (factor, newW) => {
    const { computedWidth, MAX_WIDTH, MIN_WIDTH } = this.state;
    // let newScale = this.state.zoom;
    //     newScale = (newScale * DEFAULT_SCALE_DELTA).toFixed(2);
    //     newScale = Math.ceil(newScale * 10) / 10;
    //     newScale = Math.min(MAX_WIDTH, newScale);
    const min = 0.75;
    const max = 2;
    console.log('zoom factor', factor);

    if (newW) {
      console.log('clamping zoom among', newW, MIN_WIDTH, MAX_WIDTH);
      const nw = clamp(this.isDps() ? newW / 2 : newW, MIN_WIDTH, MAX_WIDTH);

      this.setState({
        computedWidth: nw,
        pageFitOrFill: false,
        computedHeight: null,
      });
      return;
    }

    let scale = factor;
    let newWidth = computedWidth;
    if (scale > max) {
      scale = max;
    }
    if (scale < min) {
      scale = min;
    }
    console.log('zoom to ', scale);
    newWidth = Math.ceil(newWidth * scale);
    console.log(newWidth);
    console.log('zoom x scale ', newWidth);

    newWidth = clamp(newWidth, MIN_WIDTH, MAX_WIDTH);
    console.log('zoom clamped ', newWidth);

    // newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, newWidth));
    this.setState({
      // zoom: newScale,
      computedWidth: newWidth,
      computedHeight: null,
      pageFitOrFill: false,
      zoom: factor,
    });
    // if (newWidth === computedWidth) {
    //   this.handleZoomOut(5); // high factor will just zoom out max
    // }
  };

  handleZoomIn = (e, zoomFactor = DEFAULT_SCALE_DELTA) => {
    const { computedWidth, MAX_WIDTH, MIN_WIDTH } = this.state;

    console.log('zoom in', {
      computedWidth,
      zoomFactor,
      cwXfactor: computedWidth * zoomFactor,
      MAX_WIDTH,
    });
    // let newScale = this.state.zoom;
    //     newScale = (newScale * DEFAULT_SCALE_DELTA).toFixed(2);
    //     newScale = Math.ceil(newScale * 10) / 10;
    //     newScale = Math.min(MAX_WIDTH, newScale);
    const nw = Math.floor(computedWidth * zoomFactor);
    const newWidth = Math.min(MAX_WIDTH, nw);
    // newWidth = Math.max(MIN_WIDTH, newWidth);
    console.log('Zoom In', { newWidth, MAX_WIDTH });
    if (newWidth === MAX_WIDTH) {
      console.log('Zoom in hit min');
    }
    // if (newWidth <= computedWidth) {
    //   console.log('Zoom In hzo');

    //   // this.handleZoomOut(1.1); // high factor will just zoom out max
    //   this.handleZoomReset();
    //   return;
    // }
    this.setState(
      {
        // zoom: newScale,
        computedHeight: null,
        computedWidth: newWidth,
        pageFitOrFill: false,
      }
      // , () => this.center()
    );
  };

  handleZoomOut = (e, zoomFactor = DEFAULT_SCALE_DELTA) => {
    const { computedWidth, MAX_WIDTH, MIN_WIDTH } = this.state;
    // let newScale = this.state.zoom;
    //     newScale = (newScale / DEFAULT_SCALE_DELTA).toFixed(2);
    //     newScale = Math.floor(newScale * 10) / 10;
    //     newScale = Math.max(MIN_WIDTH, newScale);
    let newWidth = computedWidth;
    console.log('zoomout computedw', newWidth, computedWidth);

    newWidth = Math.ceil(newWidth / zoomFactor);
    console.log('zoomout nw', newWidth);

    newWidth = Math.max(MIN_WIDTH, newWidth);
    console.log('ZoomOut math.maxed', newWidth, MIN_WIDTH);
    if (newWidth === MIN_WIDTH) {
      console.log('Zoom out hit min');
    }
    // if (newWidth >= computedWidth) {
    //   console.log('Zoom out reset');

    //   // this.handleZoomOut(1.1); // high factor will just zoom out max
    //   this.handleZoomReset();
    //   return;
    // }
    // if (newWidth > computedWidth) newWidth = computedWidth;
    this.setState(
      {
        // zoom: newScale,
        computedHeight: null,
        computedWidth: newWidth,
        pageFitOrFill: false,
      }
      // why tho?
      // () => this.center()
    );
  };

  // handleZoomFill = () => {
  //   if ( this.state.toggleZoom === 'fit') {
  //     this.setState({
  //       zoom: this.state.pageFitScale,
  //     });
  //   } else if ( this.state.toggleZoom === 'fill') {
  //     this.setState({
  //       zoom: this.state.pageFillScale,
  //     });
  //   }
  // }

  isDps = (args = {}) => {
    const {
      pageNumber = this.state.pageNumber,
      numPages = this.state.numPages,
      dps = this.state.dps,
    } = args;
    // return true if dps is on, and we're not on the first or last page, and the last page isn't a spread
    // as they are displayed singularly regardless of dps / single
    const isFirst = pageNumber === 1;
    const isLast = pageNumber === numPages && numPages % 2 !== 1;

    return dps && !isFirst && !isLast;
  };

  // calculateFit = () => {
  //   const { width, height } = this.state;

  //   const canvas = document.querySelector('.react-pdf__Page__canvas');
  //   const container = document.querySelector('.react-pdf__Document');
  //   // this.setCanvas();
  //   // console.log('canvas:',canvas.width, canvas.height);
  //   const isDps = this.isDps();
  //   // const dpsOrSingleWith = isDps ? canvas.width * 2 : canvas.width;

  //   // console.log('dpsOrSingleWith', dpsOrSingleWith);
  //   // const fillWidth = dps ? pdfWidth * 2 >= (width - leftMargin) : pdfWidth >= (width - leftMargin);
  //   // const fillHeight = pdfHeight >= (height - topMargin);
  //   // const containerWidth = this.container.clientWidth;
  //   // const containerHeight = this.container.clientHeight;

  //   const aspectRatio = container.clientWidth / container.clientHeight;
  //   const viewportAspectRatio = width / height;
  //   // const viewportAspectRatio = (width - leftMargin ) / (height - topMargin);
  //   console.group();
  //   console.log(
  //     'pdf aspect ratio',
  //     aspectRatio,
  //     'viewport aspect ratio',
  //     viewportAspectRatio
  //   );
  //   console.log('vh:', height);
  //   console.log('vw:', width);

  //   let newPageFitScale;
  //   let computedWidth;

  //   // calculate fit width
  //   // loz you nub it's always height / aspecRatio ??
  //   console.log(
  //     height * viewportAspectRatio,
  //     width * viewportAspectRatio,
  //     height / viewportAspectRatio,
  //     width / viewportAspectRatio
  //   );
  //   console.log(
  //     height * aspectRatio,
  //     width * aspectRatio,
  //     height / aspectRatio,
  //     width / aspectRatio
  //   );
  //   if (viewportAspectRatio < aspectRatio) {
  //     // single
  //     console.log('[] va < pdf a', width);
  //     // newPageFitScale = (width  - leftMargin) / container.clientWidth;

  //     if (isDps) {
  //       console.log('[setscale] va < pdf a && dps', height / aspectRatio);

  //       // idk what I'm doing
  //       computedWidth = (height * aspectRatio) / 2;
  //     } else {
  //       console.log('[setScale]', height * aspectRatio);

  //       computedWidth = height * aspectRatio;
  //     }
  //   } else if (isDps) {
  //     console.log(
  //       '[setscale] va > pdf a && dps',
  //       height / aspectRatio,
  //       height * aspectRatio
  //     );
  //     // newPageFitScale = height / container.clientHeight
  //     computedWidth = (height * aspectRatio) / 2;
  //   } else {
  //     console.log('[setscale] va > pdf a', height * aspectRatio);
  //     // correct !?
  //     computedWidth = height * aspectRatio;
  //   }
  //   console.groupEnd();
  //   return computedWidth;
  // };

  // sets computed width to the fill width
  // then centers the page
  setPageFill = () => {
    const {
      dps,
      width,
      height,
      fillWidth,
      fitWidth,
      fitHeight,
      pageNumber,
      numPages,
    } = this.state;

    console.log('setPageFill:', fillWidth, this.isDps() ? width / 2 : width);
    this.setState(
      {
        pageFitOrFill: true,
        toggleZoom: 'fill',
        computedWidth: fillWidth,
        computedHeight: null,
        MIN_WIDTH: fillWidth,
      },
      // bounds are getting set a bit late, this might fix centering
      () => setTimeout(() => this.center(), 50)
    );
  };

  setPageFit = () => {
    const {
      el,
      dps,
      width,
      height,
      fillWidth,
      fitWidth,
      fitHeight,
    } = this.state;
    // the fitWidth state is essentially wrong so we're just getting the right val here
    // ur dumb, the new width that the pdf will be hasn't changed yet, and is the fuckin value we need.
    console.log('setPageFit: (width)', { fitWidth }, { fillWidth });
    this.setState(
      {
        pageFitOrFill: true,
        toggleZoom: 'fit',
        computedWidth: fitWidth, // should be null or the right val lol
        computedHeight: fitHeight,
        MIN_WIDTH: fitWidth,
      },
      () => setTimeout(() => this.center(), 50)
    );
  };

  // lol this is the same as setPageFitOrFill? except the moreAnchorEl
  handleZoomReset = () => {
    const { toggleZoom } = this.state;

    if (toggleZoom === 'fit') {
      this.setPageFill();
    } else {
      this.setPageFit();
    }
    this.setState({ moreAnchorEl: null });
  };

  handleSwipeRight = () => {
    // I'm removing the toggleZoom requirement,
    // in favour of allowing swiping when
    // at the bounds regardless of zoom
    //  (handled in the GestureHandler useDrag function)
    // nvm it happens unintentionally on mobile
    const { toggleZoom } = this.state;
    toggleZoom && this.handlePrevious();
  };

  handleSwipeLeft = () => {
    const { toggleZoom } = this.state;
    toggleZoom && this.handleNext();
  };

  // renderAnnotations() {
  //   const { annotations } = this.state;

  //   if (!annotations) {
  //     return;
  //   }

  //   const { linkService, page } = this.context;
  //   const viewport = this.viewport.clone({ dontFlip: true });

  //   const parameters = {
  //     annotations,
  //     div: this.annotationLayer,
  //     linkService,
  //     page,
  //     viewport,
  //   };

  //   try {
  //     PDFJS.AnnotationLayer.render(parameters);
  //     this.onRenderSuccess();
  //   } catch (error) {
  //     this.onRenderError(error);
  //   }
  // }
  zoomControls = () => {
    const { classes } = this.props;

    const { computedWidth, dps, toggleZoom, MAX_WIDTH, MIN_WIDTH } = this.state;
    return (
      // <span
      //   className={classes.pdfControls}
      //   key="zoomControls"
      // >
      <Grid item xs={6} sm={4} md={4}>
        <Grid
          container
          justify="flex-end"
          alignItems="center"
          spacing={16}
          style={{ flexWrap: 'no-wrap' }}
        >
          <Grid item>
            {/* toggle zoom */}
            <Tooltip
              id="tooltip-toggle-zoom"
              title={toggleZoom !== 'fit' ? 'page fit' : 'Page fill'}
              placement="bottom"
            >
              <IconButton
                disableRipplez
                onClick={this.handleZoomReset}
                className={classnames(
                  classes.navButton,
                  classes.toggleZoomIconContainer,
                  toggleZoom !== 'fit'
                    ? classes.toggleZoomCol
                    : classes.toggleZoomRow
                )}
              >
                <span className={classes.toggleZoomWrapper}>
                  <Icon
                    className={classnames(
                      classes.navButton,
                      classes.toggleZoomIcons,
                      toggleZoom !== 'fit'
                        ? classes.toggleZoomIconCol2
                        : classes.toggleZoomIconRow2
                    )}
                  >
                    {'keyboard_arrow_up'}
                  </Icon>
                  <Icon
                    className={classnames(
                      classes.navButton,
                      classes.toggleZoomIcons,
                      toggleZoom !== 'fit'
                        ? classes.toggleZoomIconCol1
                        : classes.toggleZoomIconRow1
                    )}
                  >
                    {'keyboard_arrow_down'}
                  </Icon>
                </span>
              </IconButton>
            </Tooltip>
          </Grid>

          {/* toggle dps */}
          <Grid item>
            <Tooltip
              id="tooltip-toggle-dps"
              title={dps ? 'Single page' : 'Double page'}
              placement="bottom"
            >
              <IconButton
                disableRipplez
                className={classes.navButton}
                onClick={this.toggleDps}
              >
                {dps ? (
                  <Icon>insert_drive_file</Icon>
                ) : (
                  <React.Fragment>
                    <Icon style={{ transform: `translateX(2px) scaleX(-1)` }}>
                      insert_drive_file
                    </Icon>
                    <Icon style={{ transform: `translateX(-2px)` }}>
                      insert_drive_file
                    </Icon>
                  </React.Fragment>
                  // <Icon style={{ transform: 'rotate(90deg)' }}>view_stream</Icon>
                )}
              </IconButton>
            </Tooltip>
          </Grid>
          {/* zoom in / out */}
          <Hidden smDown>
            <Grid item>
              <Tooltip
                id="tooltip-zoom-out"
                title="Zoom out"
                placement="bottom"
              >
                <span>
                  <IconButton
                    classes={{
                      disabled: classes.iconButtonDisabled,
                    }}
                    className={classes.navButton}
                    disabled={computedWidth <= MIN_WIDTH}
                    onClick={this.handleZoomOut}
                  >
                    <Icon>zoom_out</Icon>
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item>
              <Tooltip id="tooltip-zoom-in" title="Zoom in" placement="bottom">
                <span>
                  <IconButton
                    classes={{
                      disabled: classes.iconButtonDisabled,
                    }}
                    className={classes.navButton}
                    disabled={computedWidth >= MAX_WIDTH}
                    onClick={this.handleZoomIn}
                  >
                    <Icon>zoom_in</Icon>
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          </Hidden>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {
      pageNumber,
      numPages,
      fitWidth,
      fitHeight,
      fillWidth,
      toggleZoom,
      zoom,
      computedWidth,
      computedHeight,
      MIN_WIDTH,
      MAX_WIDTH,
      dps,
      paginationAnchorEl,
      moreAnchorEl,
      canvas,
      topMargin,
      pageRenderedBeginning,
      pageRenderedMiddle,
      pageRenderedEnd,
      beginningPage,
      middlePage,
      endPage,
      pageCursor,
    } = this.state;
    // console.log('cstate on render', this.state);
    const { pdf, classes } = this.props;

    // we use these vals to keep the pre-rendered, out of viewport pages
    // at the same dimensions, so zooming doesn't force them to re-render
    const defaultWidth = toggleZoom === 'fit' ? null : fillWidth;
    const defaultHeight = toggleZoom === 'fit' ? fitHeight : null;
    const fileUrl = getCFUrl(pdf.fileKey);

    return (
      <div
        ref={(ref) => (this.container = ref)}
        className={classes.container}
        style={{ minHeight: `calc(100vh - ${topMargin}px)` }}
      >
        {pdf && (
          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar className={classes.toolBar}>
              <Grid container alignItems="center" justify="space-between">
                <PdfTitle
                  pdf={pdf}
                  goBack={this.goBack}
                  classes={classes}
                  authed={this.props.authed}
                />

                <Grid item className={classes.center}>
                  {numPages && (
                    <Pagination
                      setAnchorEl={this.setPaginationAnchor}
                      paginationMenuItem={classes.paginationMenuItem}
                      handlePageChange={this.handlePageChange}
                      isDps={this.isDps()}
                      paginationAnchorEl={paginationAnchorEl}
                      dps={dps}
                      numPages={numPages}
                      pageNumber={pageNumber}
                      handleNext={this.handleNext}
                      handlePrevious={this.handlePrevious}
                      handleLast={this.handleLast}
                      handleFirst={this.handleFirst}
                      handleKeyPress={this.handleKeyPress}
                      disabledClass={classes.iconButtonDisabled}
                      buttonRoot={classes.buttonRoot}
                    />
                  )}
                </Grid>

                {this.zoomControls()}
              </Grid>
              {/* <Grow in={!this.state.mouseDown}> */}
              <div className={classes.pdfToolsLeft}>
                {this.state.showPdf && (
                  <Tooltip
                    id="tooltip-thumbs"
                    title={
                      this.state.showThumbs
                        ? 'Hide thumbnails'
                        : 'Show thumbnails'
                    }
                    placement="bottom"
                  >
                    <Button
                      component="a"
                      disableRipplez
                      variant="fab"
                      color="primary"
                      mini
                      onClick={() =>
                        this.setState({ showThumbs: !this.state.showThumbs })
                      }
                    >
                      <Icon>
                        {this.state.showThumbs ? 'close' : 'view_module'}
                      </Icon>
                    </Button>
                  </Tooltip>
                )}
              </div>
              {/* </Grow> */}
              <div className={classes.pdfToolsRight}>
                <Tooltip
                  id="tooltip-download"
                  title="Download pdf file"
                  placement="bottom"
                >
                  <Button
                    style={{ marginLeft: 12 }}
                    disableRipplez
                    variant="fab"
                    color="primary"
                    mini
                    href={fileUrl}
                    target="_blank"
                  >
                    <Icon>file_download</Icon>
                  </Button>
                </Tooltip>
                {this.props.authed && this.props.canEdit && (
                  <Tooltip
                    id="tooltip-download"
                    title="Edit pdf"
                    placement="bottom"
                  >
                    <Button
                      style={{ marginLeft: 12 }}
                      component={Link}
                      to={`/edit/${pdf.id}`}
                      disableRipplez
                      variant="fab"
                      color="primary"
                      mini
                    >
                      <Icon>edit</Icon>
                    </Button>
                  </Tooltip>
                )}
              </div>
            </Toolbar>
          </AppBar>
        )}

        {pdf.thumbs && (
          <PdfThumbs
            dps={dps}
            status={pdf.pdfInfoById?.status}
            classes={classes}
            showThumbs={this.state.showThumbs}
            thumbs={pdf.thumbs || []}
            handlePageChange={this.handlePageChange}
            pageNumber={pageNumber}
            numPages={numPages}
          />
        )}
        {this.state.showPdf && (
          // <GestureHandler
          //   ref={(gh) => (this.gestureHandler = gh)}
          //   width={this.state.width}
          //   height={this.state.height}
          //   el=".react-pdf__Document"
          //   container=".react-pdf__Page__canvas"
          //   // elWidth={ this.isDps() ? canvas.width * 2 : canvas.width}
          //   // elHeight={canvas.height}
          //   topMargin={topMargin}
          //   doc={this.doc}
          //   scaleDelta={DEFAULT_SCALE_DELTA}
          //   doubletap={this.handleDoubleClick}
          //   pinchend={this.pinchend}
          //   swiperight={this.handleSwipeRight}
          //   swipeleft={this.handleSwipeLeft}
          //   onTouchStart={this.handleMouseDown}
          //   onTouchEnd={this.handleMouseUp}
          // >
          //   {(state) => (
          // console.log(state.x, state.y);
          <React.Fragment>
            <PdfLoading
              show={!pageRenderedBeginning && pageCursor === 'beginning'}
            />
            <PdfLoading show={!pageRenderedMiddle && pageCursor === 'middle'} />
            <PdfLoading show={!pageRenderedEnd && pageCursor === 'end'} />
            {/* <ScrollIndicator
              pos="left"
              transform={state.leftIndicatorTransform}
              last_posY={state.last_posY}
            />
            <ScrollIndicator
              pos="right"
              transform={state.rightIndicatorTransform}
              last_posY={state.last_posY}
            /> */}
            {/* <div
                  style={{
                    transition: state.isPanning
                      ? 'all 0ms'
                      : 'all 300ms ease-out',
                    transform: `translate3d(${state.x}px, ${state.y}px, 0) scale3d(${state.scale}, ${state.scale}, 1)`,
                    transformOrigin: state.center
                      ? `${state.center.x}px ${state.center.y}px`
                      : '0 0',
                  }}
                > */}
            {/* this.min_posX = 0;
    this.max_posX = width - elWidth;
    this.max_posY = height - elHeight;
    this.min_posY = 0; */}
            {/* <PdfLoading
              show={
                this.isDps()
                  ? !this.state.pageRenderedL && !this.state.pageRenderedR
                  : !this.state.pageRenderedL
              } 
            />*/}

            <GestureHandler__Experimental
              handleZoom={this.handleZoom}
              topMargin={topMargin}
              onDoubleClick={this.handleDoubleClick}
              swipeRight={this.handleSwipeRight}
              swipeLeft={this.handleSwipeLeft}
              goForward={this.handleNext}
              goBackward={this.handlePrevious}
              shouldCenter={this.state.center}
              computedWidth={this.isDps() ? computedWidth * 2 : computedWidth}
              computedHeight={computedHeight}
              pdfEl={this.doc}

              // ref={(r) => (this.handler = r)}
              // pdfEl={this.state.el}
            >
              <Document>
                {({ Document, Page }) => (
                  <Document
                    inputRef={(doc) => (this.doc = doc)}
                    // className={classnames(classes.hideOverflow, dps && classes.pdfDocument)}
                    className={classnames(
                      classes.hideOverflow,
                      // ?? dps &&
                      classes.pdfDocument
                      // this.state.pageRenderedL
                      //   ? this.state.direction === 'left'
                      //     ? classes.showPageL
                      //     : classes.showPageR
                      //   : this.state.direction === 'left'
                      //   ? classes.hidePageL
                      //   : classes.hidePageR
                    )}
                    //  className="pdf-document"
                    file={fileUrl}
                    // renderMode="svg"
                    loading={<PdfLoading />}
                    options={{
                      cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/cmaps/`,
                      cMapPacked: true,
                      disableRange: true,
                    }}
                    // file="https://cors-anywhere.herokuapp.com/https://drive.google.com/uc?export=download&id=0BxCAYzqj734aRkxhTW1lM3FnSzg"
                    onLoadSuccess={this.onDocumentLoad}
                    error={<Error status={pdf.pdfInfoById?.status} />}
                    onLoadError={(error) => {
                      console.error(error);
                      // alert(
                      //   `Error while loading document! ${JSON.stringify(error)}`
                      // );
                    }}
                    onItemClick={this.internalLinkPress}
                  >
                    {pageNumber > 0 &&
                      beginningPage > 0 &&
                      beginningPage <= numPages && (
                        <Page
                          data-cursor="beginning"
                          renderAnnotations
                          // scale={zoom}
                          // onLoadProgress={this.onPageLoadProgressR}
                          onLoadProgress={this.onLoadProgress}
                          onLoadSuccess={this.onPageLoadBeginning}
                          onRenderSuccess={this.onRenderSuccessBeginning}
                          onGetAnnotationsSuccess={(a) =>
                            this.getAnnotations(a, beginningPage)
                          }
                          // onGetAnnotationsSuccess={this.getAnnotationsR}
                          // onRenderSuccess={this.onRenderSuccessR}
                          renderTextLayer={false}
                          width={
                            pageCursor !== 'beginning'
                              ? defaultWidth
                              : computedHeight
                              ? null
                              : computedWidth
                          }
                          height={
                            pageCursor !== 'beginning'
                              ? defaultHeight
                              : computedHeight
                          }
                          className={
                            pageCursor === 'beginning'
                              ? classes.page
                              : classes.pageHidden
                          }
                          pageNumber={beginningPage}
                          loading={<PdfLoading show />}
                        />
                      )}

                    {dps &&
                      beginningPage !== 1 &&
                      beginningPage + 1 !== 1 &&
                      beginningPage < numPages && (
                        <Page
                          data-cursor="beginning"
                          renderAnnotations
                          onGetAnnotationsSuccess={(a) =>
                            this.getAnnotations(a, beginningPage + 1)
                          }
                          // scale={zoom}
                          // onLoadProgress={this.onPageLoadProgressR}

                          onLoadSuccess={this.onPageLoadBeginning}
                          onRenderSuccess={this.onRenderSuccessBeginning}
                          // onGetAnnotationsSuccess={this.getAnnotationsR}
                          // onRenderSuccess={this.onRenderSuccessR}
                          renderTextLayer={false}
                          width={
                            pageCursor !== 'beginning'
                              ? defaultWidth
                              : computedHeight
                              ? null
                              : computedWidth
                          }
                          height={
                            pageCursor !== 'beginning'
                              ? defaultHeight
                              : computedHeight
                          }
                          className={
                            pageCursor === 'beginning'
                              ? classes.page
                              : classes.pageHidden
                          }
                          pageNumber={beginningPage + 1}
                          loading={<PdfLoading show />}
                        />
                      )}
                    <Page
                      data-cursor="middle"
                      className={
                        pageCursor === 'middle'
                          ? classes.page
                          : classes.pageHidden
                      }
                      renderAnnotations
                      onGetAnnotationsSuccess={(a) =>
                        this.getAnnotations(a, middlePage)
                      }
                      // onGetAnnotationsSuccess={this.getAnnotationsMiddle}
                      onLoadSuccess={this.onPageLoadMiddle}
                      onRenderSuccess={this.onRenderSuccessMiddle}
                      // scale={zoom}
                      renderTextLayer={false}
                      width={
                        pageCursor !== 'middle'
                          ? defaultWidth
                          : computedHeight
                          ? null
                          : computedWidth
                      }
                      height={
                        pageCursor !== 'middle' ? defaultHeight : computedHeight
                      }
                      pageNumber={middlePage}
                      loading={<PdfLoading show />}
                    />
                    {dps && middlePage !== 1 && middlePage < numPages && (
                      <Page
                        data-cursor="middle"
                        className={
                          pageCursor === 'middle'
                            ? classes.page
                            : classes.pageHidden
                        }
                        renderAnnotations
                        onGetAnnotationsSuccess={(a) =>
                          this.getAnnotations(a, middlePage + 1)
                        }
                        // onGetAnnotationsSuccess={this.getAnnotationsMiddle}
                        onLoadSuccess={this.onPageLoadMiddle}
                        onRenderSuccess={this.onRenderSuccessMiddle}
                        // scale={zoom}
                        renderTextLayer={false}
                        width={
                          pageCursor !== 'middle'
                            ? defaultWidth
                            : computedHeight
                            ? null
                            : computedWidth
                        }
                        height={
                          pageCursor !== 'middle'
                            ? defaultHeight
                            : computedHeight
                        }
                        pageNumber={middlePage + 1}
                        loading={<PdfLoading show />}
                      />
                    )}
                    {endPage <= numPages && (
                      <Page
                        data-cursor="end"
                        renderAnnotations
                        onGetAnnotationsSuccess={(a) =>
                          this.getAnnotations(a, endPage)
                        }
                        // scale={zoom}
                        // onLoadProgress={this.onPageLoadProgressR}

                        onLoadSuccess={this.onPageLoadEnd}
                        onRenderSuccess={this.onRenderSuccessEnd}
                        // onGetAnnotationsSuccess={this.getAnnotationsEnd}
                        // onRenderSuccess={this.onRenderSuccessR}
                        renderTextLayer={false}
                        width={
                          pageCursor !== 'end'
                            ? defaultWidth
                            : computedHeight
                            ? null
                            : computedWidth
                        }
                        height={
                          pageCursor !== 'end' ? defaultHeight : computedHeight
                        }
                        className={
                          pageCursor === 'end'
                            ? classes.page
                            : classes.pageHidden
                        }
                        pageNumber={endPage}
                        loading={<PdfLoading show />}
                      />
                    )}
                    {dps && endPage !== 1 && endPage < numPages && (
                      <Page
                        data-cursor="end"
                        renderAnnotations
                        onGetAnnotationsSuccess={(a) =>
                          this.getAnnotations(a, endPage + 1)
                        }
                        // scale={zoom}
                        // onLoadProgress={this.onPageLoadProgressR}

                        onLoadSuccess={this.onPageLoadEnd}
                        onRenderSuccess={this.onRenderSuccessEnd}
                        // onGetAnnotationsSuccess={this.getAnnotationsEnd}
                        // onRenderSuccess={this.onRenderSuccessR}
                        renderTextLayer={false}
                        width={
                          pageCursor !== 'end'
                            ? defaultWidth
                            : computedHeight
                            ? null
                            : computedWidth
                        }
                        height={
                          pageCursor !== 'end' ? defaultHeight : computedHeight
                        }
                        className={
                          pageCursor === 'end'
                            ? classes.page
                            : classes.pageHidden
                        }
                        pageNumber={endPage + 1}
                        loading={<PdfLoading show />}
                      />
                    )}
                    {/* {pageNumber > 1 && pageNumber < numPages && dps && (
                      <Page
                        renderAnnotations
                        // scale={zoom}
                        // onLoadProgress={this.onPageLoadProgressR}

                        onLoadSuccess={this.onPageLoadR}
                        onRenderSuccess={this.onRenderSuccessR}
                        onGetAnnotationsSuccess={this.getAnnotationsR}
                        // onRenderSuccess={this.onRenderSuccessR}
                        renderTextLayer={false}
                        width={computedHeight ? null : computedWidth}
                        height={computedHeight}
                        className={classes.page}
                        pageNumber={pageNumber + 1}
                        loading={null}
                      />
                    )} */}
                  </Document>
                )}
              </Document>
            </GestureHandler__Experimental>
            {/* </div> */}
          </React.Fragment>
          //   )}
          // </GestureHandler>
        )}
        {this.state.showLightBox && (
          <LightBox
            open={this.state.showLightBox}
            v={this.state.lightBoxContent}
            closeLightBox={this.closeLightBox}
          />
        )}
      </div>
    );
  }
}
PdfViewer.propTypes = {
  pdf: PropTypes.object.isRequired,
  authed: PropTypes.bool.isRequired,
};
PdfViewer.contextTypes = {
  router: PropTypes.object.isRequired,
};
const LightBox = ({ v, closeLightBox, open }) => (
  <AlertDialog
    open={open}
    fullWidth
    fullScreen={window.innerWidth < 600}
    maxWidth="md"
    dark
    contentContainerStyle={{ padding: 0 }}
    onConfirm={closeLightBox}
    onCancel={closeLightBox}
    buttonText="close"
    message={
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          paddingTop: '56.25%',
        }}
      >
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${v}`}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </div>
    }
  />
);

const PdfLoading = ({ show }) =>
  show ? (
    <div
      style={{
        // background: 'hotpink',
        position: 'absolute',
        // width: '100vw',
        // height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        userSelect: 'none',
        // zIndex: 1100,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '50%',
          padding: 24,
          width: 120,
          height: 120,
          boxShadow: '2px 2px 15px rgba(0,0,0,0.06)',
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          'flex-direction': 'column',
        }}
      >
        {/* <Typography variant="body1" gutterBottom>
          Loading...
        </Typography> */}
        <Loading inline />
      </div>
    </div>
  ) : null;
const Error = ({ status }) => (
  <InfoBox type="error">
    Failed to load PDF file. {status && `Pdf is ${status}.`}
  </InfoBox>
);

const PdfTitle = ({ pdf, goBack, classes, authed }) => {
  const datePublished = dateConvert(pdf.datePublished);

  return (
    // <Hidden smDown>
    <Grid item xs={12} sm={4} justify="center" alignItems="flex-start">
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Hidden xsDown>
          {authed ? (
            <div>
              <a role="navigation" onClick={goBack}>
                <IconButton className={classes.navButton}>
                  <Icon>arrow_back</Icon>
                </IconButton>
              </a>
            </div>
          ) : null}
        </Hidden>
        <div className={classes.pdfTitleContainer}>
          <Typography
            color="primary.main"
            variant="body1"
            className={classes.pdfTitleText}
          >
            {pdf.publication}
          </Typography>
          <Typography
            color="primary.dark"
            variant="body2"
            className={classes.pdfSubTitleText}
          >
            {pdf.edition} {datePublished}
          </Typography>
        </div>
      </div>
    </Grid>
    // </Hidden>
  );
};
export default withStyles(styles)(PdfViewer);
